export const SEARCH_TYPES = Object.freeze({
  districtOrSchool: 'District/School',
  organization: 'Organization',
  flyer: 'Flyer',
  user: 'User',  
});